import { renewSession } from './authInterceptor';
import { forceSignOut } from './forceSignOut';

// Set (per tab) just before the reload that follows a successful renewal, so a page flagged again does not reload again
const RENEWAL_RELOAD_KEY = 'pmc_renewal_reload';

/**
 * Browser side of the server-side renewal hand-over, run once per page load with the page's `isRenewalPending` prop.
 *
 * - Not pending: forgets the reload marker of an earlier successful hand-over
 * - Pending, and this page was reached by our own renewal reload: the session is unrenewable, so sign out (no renewal call)
 * - Pending: renews like any browser request. Success reloads once so the server renders signed in; a rejected
 *   renewal has already signed out (`renewSession`); a transient failure does nothing.
 */
export const handOverPendingRenewal = async (isRenewalPending: boolean) => {
  if (!isRenewalPending) {
    sessionStorage.removeItem(RENEWAL_RELOAD_KEY);
    return;
  }

  if (sessionStorage.getItem(RENEWAL_RELOAD_KEY)) {
    sessionStorage.removeItem(RENEWAL_RELOAD_KEY);
    await forceSignOut();
    return;
  }

  try {
    await renewSession();
  } catch (_) {
    return;
  }

  sessionStorage.setItem(RENEWAL_RELOAD_KEY, '1');
  window.location.reload();
};
